const MANAGEMENT_VERTICAL_TABS = new Set([
  'dashboard',
  'management',
  'sales',
  'operations',
  'inventory'
]);

export const getManagementHeaderTab = (searchParams) =>
  searchParams.get('tab') === 'progression' ? 'progression' : 'dashboard';

export const getManagementVerticalTab = (searchParams) => {
  const vertical = searchParams.get('vertical');
  return MANAGEMENT_VERTICAL_TABS.has(vertical) ? vertical : 'dashboard';
};

export const buildManagementHeaderTabParams = (searchParams, tab) => {
  const next = new URLSearchParams(searchParams);

  if (tab === 'progression') {
    next.set('tab', 'progression');
  } else {
    next.delete('tab');
    next.delete('vertical');
  }

  return next;
};

export const buildManagementVerticalTabParams = (searchParams, vertical) => {
  const next = new URLSearchParams(searchParams);
  next.set('tab', 'progression');

  if (vertical === 'dashboard') {
    next.delete('vertical');
  } else {
    next.set('vertical', vertical);
  }

  return next;
};
